const EVENT_NAMES = {
  BUTTON_CLICK: 'button-click',
  ROW_CLICK: 'row-click',
  STATE: 'state',
  PAGE_CHANGE: 'page-change',
};

export const STATE = {
  SUCCESS: 'success',
  FAIL: 'fail',
};

export const CAMPAIGN_STATE = {
  PAUSE: 'pause',
  RUN: 'run',
};

export const AD_NEW_CAMPAIGN_BUTTON_CLICK = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'newCampaignButton',
};

export const AD_NEW_CAMPAIGN_CREATION_STATE = state => ({
  event: EVENT_NAMES.STATE,
  state,
  type: 'adNewCampaignCreationState',
});

export const AD_CAMPAIGN_CLICK = {
  event: EVENT_NAMES.ROW_CLICK,
  type: 'campaignRow',
};

export const AD_FINANCE_BUDGET_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adIncreaseBudget',
};

export const AD_FINANCE_BUDGET_INCREASE_REDIRECT_PAYMENT_STATE = state => ({
  event: EVENT_NAMES.STATE,
  state,
  type: 'adFinanceBudgetIncreaseRedirectPaymentState',
});

export const AD_FINANCE_BUDGET_INCREASE_STATE = state => ({
  event: EVENT_NAMES.STATE,
  state,
  type: 'adFinanceBudgetIncreaseState',
});

export const AD_CAMPAIGN_ADD_KEYWORD_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adCampaignAddKeywordButton',
};

export const AD_CAMPAIGN_ADD_KEYWORD_STATE = state => ({
  event: EVENT_NAMES.STATE,
  state,
  type: 'adCampaignAddKeywordState',
});

export const AD_CAMPAIGN_CHANGE_STATE = state => ({
  event: EVENT_NAMES.STATE,
  state,
  type: 'adCampaignChangeState',
});

export const AD_CAMPAIGN_DELETE_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adCampaignDeleteButton',
};

export const AD_CAMPAIGN_SEARCH_TERM_ADD_BID_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adCampaignSearchTermAddBidButton',
};

export const AD_CAMPAIGN_SEARCH_TERM_ADD_BID_MODAL_ACTION_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adCampaignSearchTermAddBidModalActionButton',
};

export const AD_CAMPAIGN_SEARCH_TERM_ADD_NEGATIVE_KEYWORD_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adCampaignSearchTermAddMegativeKeywordButton',
};

export const AD_CAMPAIGN_SEARCH_TERM_ADD_NEGATIVE_KEYWORD_MODAL_ACTION_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adCampaignSearchTermAddNegativeKeywordModalActionButton',
};

// Mail Service

export const AD_MAIL_SERVICE_ADD_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adMailServiceAddButton',
};

export const AD_MAIL_SERVICE_ADD_MODAL_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adMailServiceAddModalButton',
};

export const AD_MAIL_SERVICE_EDIT_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adMailServiceEditButton',
};

export const AD_MAIL_SERVICE_EDIT_MODAL_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adMailServiceEditModalButton',
};

export const AD_MAIL_SERVICE_REMOVE_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adMailServiceRemoveButton',
};

export const AD_MAIL_SERVICE_CHANGE_STATE = state => ({
  event: EVENT_NAMES.STATE,
  state,
  type: 'adMailServiceChangeState',
});

//  Keyword Planner

export const AD_KEYWORD_PLANNER_SEARCH_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adKeywordPlannerSearchButton',
};

export const AD_KEYWORD_PLANNER_ADD_TO_KEYWORD_ROW_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adKeywordPlannerAddToKeywordRowButton',
};

export const AD_KEYWORD_PLANNER_ADD_TO_NEGATIVE_KEYWORD_ROW_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adKeywordPlannerAddToNegativeKeywordRowButton',
};

export const AD_KEYWORD_PLANNER_ADD_TO_KEYWORD_MODAL_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adKeywordPlannerAddToKeywordModalButton',
};

export const AD_KEYWORD_PLANNER_ADD_TO_NEGATIVE_KEYWORD_MODAL_BUTTON = {
  event: EVENT_NAMES.BUTTON_CLICK,
  type: 'adKeywordPlannerAddToNegativeKeywordModalButton',
};

export const AD_KEYWORD_PLANNER_GO_TO_RESULT_PAGE = {
  event: EVENT_NAMES.PAGE_CHANGE,
  type: 'adKeywordPlannerGoToResultPage',
};
